import { render } from "./Residence.vue?vue&type=template&id=7b9a097c"
import script from "./Residence.vue?vue&type=script&lang=js"
export * from "./Residence.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Residence.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b9a097c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b9a097c', __exports__)) {
    api.reload('7b9a097c', __exports__)
  }
  
  module.hot.accept("./Residence.vue?vue&type=template&id=7b9a097c", () => {
    api.rerender('7b9a097c', render)
  })

}


export default __exports__